"use strict";

var _regeneratorRuntime = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var waterfall_1 = __importDefault(require("async/waterfall"));

var ethereumjs_util_1 = __importDefault(require("ethereumjs-util"));

var xtend_1 = __importDefault(require("xtend"));

var web3_provider_engine_1 = __importDefault(require("web3-provider-engine"));

var hooked_wallet_1 = __importDefault(require("web3-provider-engine/subproviders/hooked-wallet"));

var rpc_1 = __importDefault(require("web3-provider-engine/subproviders/rpc"));

var subscriptions_1 = __importDefault(require("web3-provider-engine/subproviders/subscriptions"));

var filters_1 = __importDefault(require("web3-provider-engine/subproviders/filters"));

var pify_1 = __importDefault(require("pify"));

var web3Utils = __importStar(require("web3-utils"));

var AuthereumSDK_1 = __importDefault(require("./AuthereumSDK"));

var Notifier_1 = __importDefault(require("./Notifier"));

var css_1 = __importDefault(require("./css"));

var utils_1 = require("./utils");

var AuthereumProvider =
/*#__PURE__*/
function (_web3_provider_engine) {
  _inherits(AuthereumProvider, _web3_provider_engine);

  function AuthereumProvider(config) {
    var _this;

    _classCallCheck(this, AuthereumProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AuthereumProvider).call(this));
    _this.lastSignTx = '';
    _this.lastSignTxTimeout = null;
    _this.lastTx = '';
    _this.lastTxTimeout = null;
    _this.lastMsg = '';
    _this.lastMsgTimeout = null;
    _this.lastTypedMsg = '';
    _this.lastTypedMsgTimeout = null;

    _this.concatAuthKeySig = function (sig) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var authKeySig;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.authereum.getLoginKeyAuthSignature();

              case 2:
                authKeySig = _context.sent;
                // Combines two hex strings into one hex string
                authKeySig = authKeySig.slice(2);
                return _context.abrupt("return", sig.concat(authKeySig));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };

    var authereumClient = null;

    if (config instanceof AuthereumSDK_1.default) {
      authereumClient = config;
      config = authereumClient.config;
    }

    _this.config = config || {};
    _this.authereum = authereumClient || new AuthereumSDK_1.default(_this.config);

    _this.initSubprovider();

    _this.isAuthereum = true;

    _this.setupNotifier();

    return _this;
  }

  _createClass(AuthereumProvider, [{
    key: "setupNotifier",
    value: function setupNotifier() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var style;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.tilDomReady();

              case 2:
                this.notifier = new Notifier_1.default({
                  networkId: this.authereum.getConfig().networkId,
                  disableNotifications: this.authereum.getConfig().disableNotifications
                });
                style = document.createElement('style');
                style.rel = 'stylesheet';
                style.type = 'text/css';
                style.textContent = css_1.default;
                style.innerText = css_1.default;
                document.body.appendChild(style);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "initSubprovider",
    value: function initSubprovider() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee27() {
        var _this2 = this;

        var throttleTimeout, walletSubprovider;
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.t0 = this.config.rpcUri;

                if (_context27.t0) {
                  _context27.next = 5;
                  break;
                }

                _context27.next = 4;
                return this.authereum.getRpcUri();

              case 4:
                _context27.t0 = _context27.sent;

              case 5:
                this.rpcUri = _context27.t0;
                throttleTimeout = 2e3;
                walletSubprovider = new hooked_wallet_1.default({
                  getAccounts: function getAccounts(cb) {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee3() {
                      var loggedIn, accountAddress;
                      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              _context3.next = 2;
                              return this.authereum.isAuthenticated();

                            case 2:
                              loggedIn = _context3.sent;

                              if (loggedIn) {
                                _context3.next = 6;
                                break;
                              }

                              if (cb) {
                                cb(null, []);
                              }

                              return _context3.abrupt("return", []);

                            case 6:
                              _context3.next = 8;
                              return this.authereum.getAccountAddress();

                            case 8:
                              accountAddress = _context3.sent;

                              if (accountAddress) {
                                _context3.next = 12;
                                break;
                              }

                              if (cb) {
                                cb(null, []);
                              }

                              return _context3.abrupt("return", []);

                            case 12:
                              if (cb) {
                                cb(null, [accountAddress]);
                              }

                              return _context3.abrupt("return", [accountAddress]);

                            case 14:
                            case "end":
                              return _context3.stop();
                          }
                        }
                      }, _callee3, this);
                    }));
                  },
                  approveTransaction: function approveTransaction(txParams, cb) {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee4() {
                      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              // Normalize data
                              // TODO: Is there a better place to do this?
                              txParams.data = utils_1.normalizeHex(txParams.data, {
                                evenLength: true,
                                addPrefix: true
                              });

                              if (cb) {
                                cb(null, true);
                              }

                              return _context4.abrupt("return", true);

                            case 3:
                            case "end":
                              return _context4.stop();
                          }
                        }
                      }, _callee4);
                    }));
                  },
                  approveMessage: function approveMessage(msgParams, cb) {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee5() {
                      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              if (cb) {
                                cb(null, true);
                              }

                              return _context5.abrupt("return", true);

                            case 2:
                            case "end":
                              return _context5.stop();
                          }
                        }
                      }, _callee5);
                    }));
                  },
                  approveTypedMessage: function approveTypedMessage(msgParams, cb) {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee6() {
                      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                        while (1) {
                          switch (_context6.prev = _context6.next) {
                            case 0:
                              if (cb) {
                                cb(null, true);
                              }

                              return _context6.abrupt("return", true);

                            case 2:
                            case "end":
                              return _context6.stop();
                          }
                        }
                      }, _callee6);
                    }));
                  },
                  signMessage: function signMessage(msgParams, cb) {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee7() {
                      var _this3 = this;

                      var currentMsg, isFirst;
                      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                        while (1) {
                          switch (_context7.prev = _context7.next) {
                            case 0:
                              currentMsg = msgParams;

                              try {
                                currentMsg = JSON.stringify(msgParams);
                              } catch (err) {} // noop
                              // Throttle if the tx is identical


                              clearTimeout(this.lastMsgTimeout);

                              if (!(this.lastMsg === currentMsg)) {
                                _context7.next = 5;
                                break;
                              }

                              return _context7.abrupt("return", this._throttledSignMessage(msgParams, cb));

                            case 5:
                              // Check if this is the first one. If so, run it through the throttling function
                              isFirst = !this.lastMsg;
                              this.lastMsg = currentMsg;
                              this.lastMsgTimeout = setTimeout(function () {
                                _this3.lastMsg = '';
                              }, throttleTimeout);

                              if (!isFirst) {
                                _context7.next = 10;
                                break;
                              }

                              return _context7.abrupt("return", this._throttledSignMessage(msgParams, cb));

                            case 10:
                              return _context7.abrupt("return", this._signMessage(msgParams, cb));

                            case 11:
                            case "end":
                              return _context7.stop();
                          }
                        }
                      }, _callee7, this);
                    }));
                  },
                  signTransaction: function signTransaction(txParams, cb) {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee8() {
                      var _this4 = this;

                      var t, currentTx, isFirst;
                      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                        while (1) {
                          switch (_context8.prev = _context8.next) {
                            case 0:
                              t = Object.assign({}, txParams);
                              t.nonce = null; // Throttle if the tx is identical

                              currentTx = JSON.stringify(t);
                              clearTimeout(this.lastSignTxTimeout);

                              if (!(this.lastSignTx === currentTx)) {
                                _context8.next = 6;
                                break;
                              }

                              return _context8.abrupt("return", this._throttledSignTransaction(txParams, cb));

                            case 6:
                              // Check if this is the first one. If so, run it through the throttling function
                              isFirst = !this.lastSignTx;
                              this.lastSignTx = currentTx;
                              this.lastSignTxTimeout = setTimeout(function () {
                                _this4.lastSignTx = '';
                              }, throttleTimeout);

                              if (!isFirst) {
                                _context8.next = 11;
                                break;
                              }

                              return _context8.abrupt("return", this._throttledSignTransaction(txParams, cb));

                            case 11:
                              return _context8.abrupt("return", this._signTransaction(txParams, cb));

                            case 12:
                            case "end":
                              return _context8.stop();
                          }
                        }
                      }, _callee8, this);
                    }));
                  },
                  processTransaction: function processTransaction(txParams, cb) {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee9() {
                      var _this5 = this;

                      var t, currentTx, isFirst;
                      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                        while (1) {
                          switch (_context9.prev = _context9.next) {
                            case 0:
                              t = Object.assign({}, txParams);
                              t.nonce = null; // Throttle if the tx is identical

                              currentTx = JSON.stringify(t);
                              clearTimeout(this.lastTxTimeout);

                              if (!(this.lastTx === currentTx)) {
                                _context9.next = 6;
                                break;
                              }

                              return _context9.abrupt("return", this._throttledProcessTransaction(txParams, cb));

                            case 6:
                              // Check if this is the first one. If so, run it through the throttling function
                              isFirst = !this.lastTx;
                              this.lastTx = currentTx;
                              this.lastTxTimeout = setTimeout(function () {
                                _this5.lastTx = '';
                              }, throttleTimeout);

                              if (!isFirst) {
                                _context9.next = 11;
                                break;
                              }

                              return _context9.abrupt("return", this._throttledProcessTransaction(txParams, cb));

                            case 11:
                              return _context9.abrupt("return", this._processTransaction(txParams, cb));

                            case 12:
                            case "end":
                              return _context9.stop();
                          }
                        }
                      }, _callee9, this);
                    }));
                  },
                  approvePersonalMessage: function approvePersonalMessage(msgParams, cb) {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee10() {
                      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                        while (1) {
                          switch (_context10.prev = _context10.next) {
                            case 0:
                              if (cb) {
                                cb(null, true);
                              }

                              return _context10.abrupt("return", true);

                            case 2:
                            case "end":
                              return _context10.stop();
                          }
                        }
                      }, _callee10);
                    }));
                  },
                  signPersonalMessage: function signPersonalMessage(msgParams, cb) {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee11() {
                      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                        while (1) {
                          switch (_context11.prev = _context11.next) {
                            case 0:
                              return _context11.abrupt("return", walletSubprovider.signMessage(msgParams, cb));

                            case 1:
                            case "end":
                              return _context11.stop();
                          }
                        }
                      }, _callee11);
                    }));
                  },
                  signTypedMessage: function signTypedMessage(msgParams, cb) {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee12() {
                      var _this6 = this;

                      var currentTypedMsg, isFirst;
                      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                        while (1) {
                          switch (_context12.prev = _context12.next) {
                            case 0:
                              currentTypedMsg = msgParams;

                              try {
                                currentTypedMsg = JSON.stringify(msgParams);
                              } catch (err) {} // noop
                              // Throttle if the tx is identical


                              clearTimeout(this.lastTypedMsgTimeout);

                              if (!(this.lastTypedMsg === currentTypedMsg)) {
                                _context12.next = 5;
                                break;
                              }

                              return _context12.abrupt("return", this._throttledSignTypedMessage(msgParams, cb));

                            case 5:
                              // Check if this is the first one. If so, run it through the throttling function
                              isFirst = !this.lastTypedMsg;
                              this.lastTypedMsg = currentTypedMsg;
                              this.lastTypedMsgTimeout = setTimeout(function () {
                                _this6.lastTypedMsg = '';
                              }, throttleTimeout);

                              if (!isFirst) {
                                _context12.next = 10;
                                break;
                              }

                              return _context12.abrupt("return", this._throttledSignTypedMessage(msgParams, cb));

                            case 10:
                              return _context12.abrupt("return", this._signTypedMessage(msgParams, cb));

                            case 11:
                            case "end":
                              return _context12.stop();
                          }
                        }
                      }, _callee12, this);
                    }));
                  },
                  estimateGas: function estimateGas(txParams, cb) {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee13() {
                      var gas;
                      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
                        while (1) {
                          switch (_context13.prev = _context13.next) {
                            case 0:
                              gas = '0x7A120';

                              if (cb) {
                                cb(null, gas);
                              }

                              return _context13.abrupt("return", gas);

                            case 3:
                            case "end":
                              return _context13.stop();
                          }
                        }
                      }, _callee13);
                    }));
                  },
                  getGasPrice: function getGasPrice(cb) {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee14() {
                      var gasPrice;
                      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
                        while (1) {
                          switch (_context14.prev = _context14.next) {
                            case 0:
                              gasPrice = '0x12A05F200';

                              if (cb) {
                                cb(null, gasPrice);
                              }

                              return _context14.abrupt("return", gasPrice);

                            case 3:
                            case "end":
                              return _context14.stop();
                          }
                        }
                      }, _callee14);
                    }));
                  }
                });

                this._processTransaction = function (txParams, cb) {
                  return __awaiter(_this2, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee15() {
                    var didApprove, signedTransaction, transactionHash;
                    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
                      while (1) {
                        switch (_context15.prev = _context15.next) {
                          case 0:
                            _context15.prev = 0;
                            _context15.next = 3;
                            return walletSubprovider.approveTransaction(txParams);

                          case 3:
                            didApprove = _context15.sent;
                            _context15.next = 6;
                            return pify_1.default(walletSubprovider.checkApproval)('transaction', didApprove);

                          case 6:
                            _context15.next = 8;
                            return pify_1.default(walletSubprovider.fillInTxExtras.bind(walletSubprovider))(txParams);

                          case 8:
                            txParams = _context15.sent;
                            _context15.next = 11;
                            return pify_1.default(walletSubprovider.signTransaction.bind(walletSubprovider))(txParams);

                          case 11:
                            signedTransaction = _context15.sent;
                            transactionHash = web3Utils.sha3(signedTransaction);

                            if (cb) {
                              cb(null, transactionHash);
                            }

                            return _context15.abrupt("return", transactionHash);

                          case 17:
                            _context15.prev = 17;
                            _context15.t0 = _context15["catch"](0);

                            if (!cb) {
                              _context15.next = 22;
                              break;
                            }

                            cb(_context15.t0);
                            return _context15.abrupt("return");

                          case 22:
                            throw _context15.t0;

                          case 23:
                          case "end":
                            return _context15.stop();
                        }
                      }
                    }, _callee15, null, [[0, 17]]);
                  }));
                };

                this._throttledProcessTransaction = utils_1.throttle(function (txParams, cb) {
                  return __awaiter(_this2, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee16() {
                    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
                      while (1) {
                        switch (_context16.prev = _context16.next) {
                          case 0:
                            return _context16.abrupt("return", this._processTransaction(txParams, cb));

                          case 1:
                          case "end":
                            return _context16.stop();
                        }
                      }
                    }, _callee16, this);
                  }));
                }, throttleTimeout);

                this._signMessage = function (msgParams, cb) {
                  return __awaiter(_this2, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee17() {
                    var sig, authKeySig, loginKeyRestrictionData, combinedSig;
                    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
                      while (1) {
                        switch (_context17.prev = _context17.next) {
                          case 0:
                            _context17.prev = 0;
                            _context17.next = 3;
                            return this.authereum.signWithDappKey(msgParams.data);

                          case 3:
                            sig = _context17.sent;
                            _context17.next = 6;
                            return this.authereum.getLoginKeyAuthSignature();

                          case 6:
                            authKeySig = _context17.sent;
                            _context17.next = 9;
                            return this.authereum.getLoginKeyRestrictionData();

                          case 9:
                            loginKeyRestrictionData = _context17.sent;
                            // Combines three hex strings into one hex string
                            authKeySig = authKeySig.slice(2);
                            loginKeyRestrictionData = loginKeyRestrictionData.slice(2);
                            combinedSig = sig.concat(authKeySig, loginKeyRestrictionData);
                            this.notifier.notify('success', "Signed message \"".concat(msgParams.data, "\""), {
                              timeout: 2000
                            });

                            if (cb) {
                              cb(null, combinedSig);
                            }

                            return _context17.abrupt("return", combinedSig);

                          case 18:
                            _context17.prev = 18;
                            _context17.t0 = _context17["catch"](0);

                            if (cb) {
                              cb(_context17.t0);
                            }

                          case 21:
                          case "end":
                            return _context17.stop();
                        }
                      }
                    }, _callee17, this, [[0, 18]]);
                  }));
                };

                this._throttledSignMessage = utils_1.throttle(function (msgParams, cb) {
                  return __awaiter(_this2, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee18() {
                    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
                      while (1) {
                        switch (_context18.prev = _context18.next) {
                          case 0:
                            return _context18.abrupt("return", this._signMessage(msgParams, cb));

                          case 1:
                          case "end":
                            return _context18.stop();
                        }
                      }
                    }, _callee18, this);
                  }));
                }, throttleTimeout);

                this._signTypedMessage = function (msgParams, cb) {
                  return __awaiter(_this2, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee19() {
                    var sig, combinedSig;
                    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
                      while (1) {
                        switch (_context19.prev = _context19.next) {
                          case 0:
                            _context19.prev = 0;
                            _context19.next = 3;
                            return this.authereum.signTypedMessageWithDappKey(msgParams.data);

                          case 3:
                            sig = _context19.sent;
                            _context19.next = 6;
                            return this.concatAuthKeySig(sig);

                          case 6:
                            combinedSig = _context19.sent;
                            this.notifier.notify('success', 'Signed message', {
                              timeout: 2000
                            });

                            if (cb) {
                              cb(null, combinedSig);
                            }

                            return _context19.abrupt("return", combinedSig);

                          case 12:
                            _context19.prev = 12;
                            _context19.t0 = _context19["catch"](0);

                            if (cb) {
                              cb(_context19.t0);
                            }

                          case 15:
                          case "end":
                            return _context19.stop();
                        }
                      }
                    }, _callee19, this, [[0, 12]]);
                  }));
                };

                this._throttledSignTypedMessage = utils_1.throttle(function (msgParams, cb) {
                  return __awaiter(_this2, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee20() {
                    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
                      while (1) {
                        switch (_context20.prev = _context20.next) {
                          case 0:
                            return _context20.abrupt("return", this._signTypedMessage(msgParams, cb));

                          case 1:
                          case "end":
                            return _context20.stop();
                        }
                      }
                    }, _callee20, this);
                  }));
                }, throttleTimeout);

                this._signTransaction = function (txParams, cb) {
                  return __awaiter(_this2, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee22() {
                    var _this7 = this;

                    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
                      while (1) {
                        switch (_context22.prev = _context22.next) {
                          case 0:
                            // TODO: best practices for min gas (21000)
                            if (web3Utils.toHex(txParams.gas) === '0x5208') {
                              txParams.gas = web3Utils.toHex(500000);
                            }

                            walletSubprovider.fillInTxExtras(txParams, function (err, txWithExtras) {
                              return __awaiter(_this7, void 0, void 0,
                              /*#__PURE__*/
                              _regeneratorRuntime.mark(function _callee21() {
                                var res;
                                return _regeneratorRuntime.wrap(function _callee21$(_context21) {
                                  while (1) {
                                    switch (_context21.prev = _context21.next) {
                                      case 0:
                                        if (!err) {
                                          _context21.next = 5;
                                          break;
                                        }

                                        if (!cb) {
                                          _context21.next = 4;
                                          break;
                                        }

                                        cb(err);
                                        return _context21.abrupt("return");

                                      case 4:
                                        throw err;

                                      case 5:
                                        txWithExtras.gas = utils_1.normalizeHex(txWithExtras.gas);
                                        txWithExtras.gasPrice = utils_1.normalizeHex(txWithExtras.gasPrice);
                                        txWithExtras.value = utils_1.normalizeHex(txWithExtras.value);
                                        txWithExtras.data = utils_1.normalizeHex(txWithExtras.data);
                                        _context21.prev = 9;
                                        _context21.next = 12;
                                        return this.authereum.signTransactionWithLoginKey(txWithExtras);

                                      case 12:
                                        res = _context21.sent;

                                        if (res) {
                                          _context21.next = 16;
                                          break;
                                        }

                                        if (cb) {// NOTE: Nothing should be done here. A notification will appear from the backend/
                                          // NOTE: Throwing an error here will crash the dapp.
                                        }

                                        return _context21.abrupt("return");

                                      case 16:
                                        if (cb) {
                                          cb(null, res.signedTransactionData);
                                        }

                                        return _context21.abrupt("return", res.signedTransactionData);

                                      case 20:
                                        _context21.prev = 20;
                                        _context21.t0 = _context21["catch"](9);
                                        cb(_context21.t0);

                                      case 23:
                                      case "end":
                                        return _context21.stop();
                                    }
                                  }
                                }, _callee21, this, [[9, 20]]);
                              }));
                            });

                          case 2:
                          case "end":
                            return _context22.stop();
                        }
                      }
                    }, _callee22);
                  }));
                };

                this._throttledSignTransaction = utils_1.throttle(function (txParams, cb) {
                  return __awaiter(_this2, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee23() {
                    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
                      while (1) {
                        switch (_context23.prev = _context23.next) {
                          case 0:
                            return _context23.abrupt("return", this._signTransaction(txParams, cb));

                          case 1:
                          case "end":
                            return _context23.stop();
                        }
                      }
                    }, _callee23, this);
                  }));
                }, throttleTimeout);

                this.send = function (payload, callback) {
                  // Web3 >=1.0-beta.38 calls `send` with method and parameters
                  if (typeof payload === 'string') {
                    return new Promise(function (resolve, reject) {
                      _this2.sendAsync({
                        jsonrpc: '2.0',
                        id: 42,
                        method: payload,
                        params: callback || []
                      }, function (error, response) {
                        if (error) {
                          reject(error);
                        } else {
                          resolve(response.result);
                        }
                      });
                    });
                  } // Web3 <=1.0 beta.37 uses `send` with a callback for async queries


                  if (callback) {
                    _this2.sendAsync(payload, callback);

                    return;
                  }

                  var result = null;

                  switch (payload.method) {
                    case 'eth_uninstallFilter':
                      _this2.sendAsync(payload, function (_) {
                        return _;
                      });

                      result = true;
                      break;

                    default:
                      var message = "The Authereum Web3 object does not support synchronous methods like ".concat(payload.method, " without a callback parameter.");
                      throw new Error(message);
                  }

                  return {
                    id: payload.id,
                    jsonrpc: payload.jsonrpc,
                    result: result
                  };
                };

                walletSubprovider.handleRequest = function (payload, next, end) {
                  var self = this;
                  self._parityRequests = {};
                  self._parityRequestCount = 0; // switch statement is not block scoped
                  // sp we cant repeat var declarations

                  var txParams;
                  var msgParams;
                  var extraParams;
                  var message;
                  var address;

                  switch (payload.method) {
                    case 'eth_coinbase':
                      // process normally
                      self.getAccounts(function (err, accounts) {
                        if (err) return end(err);
                        var result = accounts[0] || null;
                        end(null, result);
                      });
                      return;

                    case 'eth_accounts':
                      // process normally
                      self.getAccounts(function (err, accounts) {
                        if (err) return end(err);
                        end(null, accounts);
                      });
                      return;

                    case 'eth_sendTransaction':
                      txParams = payload.params[0];
                      waterfall_1.default([function (cb) {
                        return self.validateTransaction(txParams, cb);
                      }, function (cb) {
                        return self.processTransaction(txParams, cb);
                      }], end);
                      return;

                    case 'eth_signTransaction':
                      txParams = payload.params[0];
                      waterfall_1.default([function (cb) {
                        return self.validateTransaction(txParams, cb);
                      }, function (cb) {
                        return self.processSignTransaction(txParams, cb);
                      }], end);
                      return;

                    case 'eth_sign':
                      // process normally
                      address = payload.params[0];
                      message = payload.params[1]; // non-standard "extraParams" to be appended to our "msgParams" obj
                      // good place for metadata

                      extraParams = payload.params[2] || {};
                      msgParams = xtend_1.default(extraParams, {
                        from: address,
                        data: message
                      });
                      waterfall_1.default([// (cb) => self.validateMessage(msgParams, cb),
                      function (cb) {
                        return self.processMessage(msgParams, cb);
                      }], end);
                      return;

                    case 'personal_sign':
                      return function () {
                        // process normally
                        var first = payload.params[0];
                        var second = payload.params[1]; // We initially incorrectly ordered these parameters.
                        // To gracefully respect users who adopted this API early,
                        // we are currently gracefully recovering from the wrong param order
                        // when it is clearly identifiable.
                        //
                        // That means when the first param is definitely an address,
                        // and the second param is definitely not, but is hex.

                        if (resemblesData(second) && resemblesAddress(first)) {
                          var warning = "The eth_personalSign method requires params ordered ";
                          warning += "[message, address]. This was previously handled incorrectly, ";
                          warning += "and has been corrected automatically. ";
                          warning += "Please switch this param order for smooth behavior in the future.";
                          console.warn(warning);
                          address = payload.params[0];
                          message = payload.params[1];
                        } else {
                          message = payload.params[0];
                          address = payload.params[1];
                        } // non-standard "extraParams" to be appended to our "msgParams" obj
                        // good place for metadata


                        extraParams = payload.params[2] || {};
                        msgParams = xtend_1.default(extraParams, {
                          from: address,
                          data: message
                        });
                        waterfall_1.default([// (cb) => self.validatePersonalMessage(msgParams, cb),
                        function (cb) {
                          return self.processPersonalMessage(msgParams, cb);
                        }], end);
                      }();

                    case 'eth_decryptMessage':
                      return function () {
                        // process normally
                        var first = payload.params[0];
                        var second = payload.params[1]; // We initially incorrectly ordered these parameters.
                        // To gracefully respect users who adopted this API early,
                        // we are currently gracefully recovering from the wrong param order
                        // when it is clearly identifiable.
                        //
                        // That means when the first param is definitely an address,
                        // and the second param is definitely not, but is hex.

                        if (resemblesData(second) && resemblesAddress(first)) {
                          var warning = "The eth_decryptMessage method requires params ordered ";
                          warning += "[message, address]. This was previously handled incorrectly, ";
                          warning += "and has been corrected automatically. ";
                          warning += "Please switch this param order for smooth behavior in the future.";
                          console.warn(warning);
                          address = payload.params[0];
                          message = payload.params[1];
                        } else {
                          message = payload.params[0];
                          address = payload.params[1];
                        } // non-standard "extraParams" to be appended to our "msgParams" obj
                        // good place for metadata


                        extraParams = payload.params[2] || {};
                        msgParams = xtend_1.default(extraParams, {
                          from: address,
                          data: message
                        });
                        waterfall_1.default([function (cb) {
                          return self.validateDecryptMessage(msgParams, cb);
                        }, function (cb) {
                          return self.processDecryptMessage(msgParams, cb);
                        }], end);
                      }();

                    case 'encryption_public_key':
                      return function () {
                        var address = payload.params[0];
                        waterfall_1.default([function (cb) {
                          return self.validateEncryptionPublicKey(address, cb);
                        }, function (cb) {
                          return self.processEncryptionPublicKey(address, cb);
                        }], end);
                      }();

                    case 'personal_ecRecover':
                      return function () {
                        message = payload.params[0];
                        var signature = payload.params[1]; // non-standard "extraParams" to be appended to our "msgParams" obj
                        // good place for metadata

                        extraParams = payload.params[2] || {};
                        msgParams = xtend_1.default(extraParams, {
                          sig: signature,
                          data: message
                        });
                        self.recoverPersonalSignature(msgParams, end);
                      }();

                    case 'eth_signTypedData':
                      // process normally
                      message = payload.params[0];
                      address = payload.params[1];
                      extraParams = payload.params[2] || {};
                      msgParams = xtend_1.default(extraParams, {
                        from: address,
                        data: message
                      });
                      waterfall_1.default([function (cb) {
                        return self.validateTypedMessage(msgParams, cb);
                      }, function (cb) {
                        return self.processTypedMessage(msgParams, cb);
                      }], end);
                      return;

                    case 'parity_postTransaction':
                      txParams = payload.params[0];
                      self.parityPostTransaction(txParams, end);
                      return;

                    case 'parity_postSign':
                      address = payload.params[0];
                      message = payload.params[1];
                      self.parityPostSign(address, message, end);
                      return;

                    case 'parity_checkRequest':
                      return function () {
                        var requestId = payload.params[0];
                        self.parityCheckRequest(requestId, end);
                      }();

                    case 'parity_defaultAccount':
                      self.getAccounts(function (err, accounts) {
                        if (err) return end(err);
                        var account = accounts[0] || null;
                        end(null, account);
                      });
                      return;

                    default:
                      next();
                      return;
                  }
                };

                walletSubprovider.validatePersonalMessage = function (msgParams, cb) {
                  return __awaiter(_this2, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee24() {
                    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
                      while (1) {
                        switch (_context24.prev = _context24.next) {
                          case 0:
                            if (cb) {
                              cb(null, true);
                            }

                            return _context24.abrupt("return", true);

                          case 2:
                          case "end":
                            return _context24.stop();
                        }
                      }
                    }, _callee24);
                  }));
                };

                walletSubprovider.validateMessage = function (msgParams, cb) {
                  return __awaiter(_this2, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee25() {
                    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
                      while (1) {
                        switch (_context25.prev = _context25.next) {
                          case 0:
                            if (cb) {
                              cb(null, true);
                            }

                            return _context25.abrupt("return", true);

                          case 2:
                          case "end":
                            return _context25.stop();
                        }
                      }
                    }, _callee25);
                  }));
                };

                this.addProvider(walletSubprovider);
                this.rpcSubProvider = new rpc_1.default({
                  rpcUrl: this.rpcUri
                }); // Replace updated rpc url if config is updated.
                // Only required for browser extension.
                // TODO: improve to not use interval
                // setInterval(() => {
                // this.rpcSubProvider.rpcUrl = this.authereum.getRpcUri()
                // }, 5e3)

                this.addProvider(new subscriptions_1.default());
                this.addProvider(new filters_1.default());
                this.addProvider({
                  setEngine: function setEngine(_) {
                    return _;
                  },
                  handleRequest: function handleRequest(payload, next, end) {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee26() {
                      return _regeneratorRuntime.wrap(function _callee26$(_context26) {
                        while (1) {
                          switch (_context26.prev = _context26.next) {
                            case 0:
                              this.rpcSubProvider.handleRequest(payload, next, end);

                            case 1:
                            case "end":
                              return _context26.stop();
                          }
                        }
                      }, _callee26, this);
                    }));
                  }
                }); // network connectivity error

                this.on('error', function (err) {
                  console.error(err.stack);
                }); // start polling

                this.start();

                this._blockTracker.removeAllListeners();

              case 28:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));
    }
  }, {
    key: "getAccounts",
    value: function getAccounts(cb) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee28() {
        var loggedIn, accountAddress;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.next = 2;
                return this.authereum.isAuthenticated();

              case 2:
                loggedIn = _context28.sent;

                if (loggedIn) {
                  _context28.next = 6;
                  break;
                }

                if (cb) {
                  cb(null, []);
                }

                return _context28.abrupt("return", []);

              case 6:
                _context28.next = 8;
                return this.authereum.getAccountAddress();

              case 8:
                accountAddress = _context28.sent;

                if (accountAddress) {
                  _context28.next = 12;
                  break;
                }

                if (cb) {
                  cb(null, []);
                }

                return _context28.abrupt("return", []);

              case 12:
                if (cb) {
                  cb(null, [accountAddress]);
                }

                return _context28.abrupt("return", [accountAddress]);

              case 14:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));
    }
  }, {
    key: "isConnected",
    value: function isConnected() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee29() {
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                return _context29.abrupt("return", this.authereum.isAuthenticated());

              case 1:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));
    }
  }, {
    key: "enable",
    value: function enable() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee30() {
        var accountAddress;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.next = 2;
                return this.authereum.login();

              case 2:
                _context30.next = 4;
                return this.authereum.getAccountAddress();

              case 4:
                accountAddress = _context30.sent;

                if (!accountAddress) {
                  _context30.next = 7;
                  break;
                }

                return _context30.abrupt("return", [accountAddress]);

              case 7:
                return _context30.abrupt("return", []);

              case 8:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));
    }
  }, {
    key: "disable",
    value: function disable() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee31() {
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                return _context31.abrupt("return", this.authereum.logout());

              case 1:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));
    }
  }, {
    key: "tilDomReady",
    value: function tilDomReady() {
      return new Promise(function (resolve) {
        if (document.readyState !== 'loading') {
          resolve();
        } else {
          document.addEventListener('DOMContentLoaded', function () {
            return resolve();
          });
        }
      });
    }
  }, {
    key: "signMessageWithAdminKey",
    value: function signMessageWithAdminKey(message) {
      return this.authereum.signMessageWithAdminKey(message);
    }
  }, {
    key: "showWidget",
    value: function showWidget() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return this.authereum.showWidget(enabled);
    }
  }, {
    key: "widgetEnabled",
    value: function widgetEnabled() {
      return this.authereum.widgetEnabled();
    }
  }]);

  return AuthereumProvider;
}(web3_provider_engine_1.default);

exports.default = AuthereumProvider;

function resemblesAddress(str) {
  var fixed = ethereumjs_util_1.default.addHexPrefix(str);
  var isValid = ethereumjs_util_1.default.isValidAddress(fixed);
  return isValid;
} // Returns true if resembles hex data
// but definitely not a valid address.


function resemblesData(str) {
  var fixed = ethereumjs_util_1.default.addHexPrefix(str);
  var isValidAddress = ethereumjs_util_1.default.isValidAddress(fixed);
  return !isValidAddress && isValidHex(str);
}

function isValidHex(data) {
  var isString = typeof data === 'string';
  if (!isString) return false;
  var isHexPrefixed = data.slice(0, 2) === '0x';
  if (!isHexPrefixed) return false;
  var nonPrefixed = data.slice(2);
  var hexRegex = /^[0-9A-Fa-f]+$/g;
  var isValid = nonPrefixed.match(hexRegex);
  return isValid;
}